__turbopack_context__.v({
  "card": "page-module__gd1dcq__card",
  "cardDesc": "page-module__gd1dcq__cardDesc",
  "cardMedia": "page-module__gd1dcq__cardMedia",
  "cardTitle": "page-module__gd1dcq__cardTitle",
  "category": "page-module__gd1dcq__category",
  "empty": "page-module__gd1dcq__empty",
  "featured": "page-module__gd1dcq__featured",
  "featuredDesc": "page-module__gd1dcq__featuredDesc",
  "featuredMedia": "page-module__gd1dcq__featuredMedia",
  "featuredTitle": "page-module__gd1dcq__featuredTitle",
  "grid": "page-module__gd1dcq__grid",
  "inside": "page-module__gd1dcq__inside",
  "intro": "page-module__gd1dcq__intro",
  "main": "page-module__gd1dcq__main",
  "media": "page-module__gd1dcq__media",
  "mediaImg": "page-module__gd1dcq__mediaImg",
  "title": "page-module__gd1dcq__title",
});
